import { render, staticRenderFns } from "./ChangePhoneNumber.vue?vue&type=template&id=59effe45"
import script from "./ChangePhoneNumber.vue?vue&type=script&lang=js"
export * from "./ChangePhoneNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports